export default `6.10.4${process.env.NODE_ENV === "development" ? "-dev" : ""}`;
